// Types
import { AppPermissions } from '../../constants/Permissions';

// Utils
import { dateHeader, formatCellDate } from './timeModeCell';
import { Contract } from '../../types/Contract';
import GridAction from '../../components/common/GridAction';

export const makeContractOverviewColumns = (onEdit, onDelete) => {
  const col = [
    {
      id: 'edit-delete',
      header: '',
      accessorKey: 'id',
      headerClassName: 'react-table-header-align-center',
      sortable: false,
      enableColumnFilter: false,
      size: 50,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const { id } = row.original as Contract;
        return (
          <GridAction
            onEdit={onEdit}
            onDeleted={onDelete}
            editPermission={AppPermissions.Comment.Edit}
            deletePermission={AppPermissions.Comment.Delete}
            isDisabled={row.original.isSecondaryReference}
            row={row.original}
            id={id}
          />
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 180,
    },
    {
      header: 'Description',
      accessorKey: 'description',
      sortable: false,
      enableColumnFilter: true,
      size: 180,
    },
    {
      header: dateHeader('Start Date'),
      accessorKey: 'startDate',
      enableColumnFilter: false,
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.startDate),
    },
    {
      header: dateHeader('End Date'),
      accessorKey: 'endDate',
      enableColumnFilter: false,
      size: 110,
      cell: ({ row, table }) => (row.original.endDate ? formatCellDate(table, row.original.endDate) : null),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: 'Created By',
      accessorKey: 'createdUserName',
      size: 110,
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
    {
      header: 'Modified By',
      accessorKey: 'modifiedUserName',
      size: 110,
    },
  ] as Array<any>;

  return col;
};
